import { BubblehousePointsRounding } from "@redotech/cockroachdb-codegen/congodb/bubblehouse-points-rounding";
import * as z from "zod";

export const setBubblehouseIntegration = {
  name: "setBubblehouseIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    sharedSecret: z.base64("Shared secret must be base64-encoded"),
    shopSlug: z.string().min(1, "Shop slug is required"),
    keyId: z.string().min(1, "Key ID is required"),
    pointsPerDollar: z.number().positive().default(1),
    pointsRounding: z
      .enum(BubblehousePointsRounding)
      .default(BubblehousePointsRounding.Nearest),
  }),
  output: z.object({}),
};
